// 部品 ボタン左寄せ用棚
import React from 'react';
import { Row, Col } from 'react-bootstrap';
var RowLeftButton = function (_a) {
    var children = _a.children;
    return (React.createElement(Row, { className: "row-left-button" },
        React.createElement(Col, { className: "text-left", xl: 6, lg: 6, md: 6, sm: 6, xs: 12 }, children),
        React.createElement(Col, { xl: 6, lg: 6, md: 6, sm: 6, xs: 12 })));
};
export default RowLeftButton;
